export const mutations = {
  GROUP_FETCH_LIST: "GROUP_FETCH_LIST",
  GROUP_ADD: "GROUP_ADD",
  GROUP_UPDATE: "GROUP_UPDATE",
  GROUP_DELETE: "GROUP_DELETE"
};

export const actions = {
  GROUP_FETCH_LIST: "fetchGroups",
  GROUP_GET_PAGES: "getGroupPages",
  GROUP_CREATE: "createGroup",
  GROUP_UPDATE: "updateGroup",
  GROUP_DELETE: "deleteGroup"
};
